export default {
    PROGRESSIVE: 'progressive',
    BAR: 'bar',
};
export const eligibleCarouselType = ['snaptogrid', 'tabbed'];
